import classNames from 'classnames'

import { isEmailInput, normalizeEmailInputValue } from './emailInput'

interface IProps {
  id: string
  containerClassName?: string
  className?: string
  type: string
  label: string
  placeholder: string
  showLabel?: boolean
  value: any
  disabled?: boolean
  hideErrors?: boolean
  inputRef?: any
  onChange: (e: any) => void
}

export const ControlledInput = (props: IProps) => {
  const {
    id,
    containerClassName,
    className,
    type = 'text',
    showLabel = false,
    label,
    placeholder,
    value,
    disabled,
    hideErrors,
    inputRef,
    onChange
  } = props
  const shouldNormalizeEmail = isEmailInput({ type, id, label })
  const handleChange = (e: any) => {
    e.target.value = normalizeEmailInputValue(e.target.value, shouldNormalizeEmail)
    onChange(e)
  }

  return (
    <div className={classNames(!hideErrors && 'mb-4', hideErrors && '!mb-0 !pb-0', containerClassName)}>
      <label className={classNames('block pl-2 pb-2 text-sm text-text-muted font-bold', { 'sr-only': !showLabel })} htmlFor={id}>
        {label}
      </label>
      <div className='relative'>
        <input
          id={id}
          ref={inputRef}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          disabled={disabled}
          autoCapitalize={shouldNormalizeEmail ? 'none' : undefined}
          spellCheck={shouldNormalizeEmail ? false : undefined}
          className={classNames(
            'input-bordered border-border disabled:border-border bg-surface disabled:bg-text/5 placeholder:text-text/30 text-text input w-full text-sm  h-[35px] sm:h-[40px] rounded-[20px] focus:outline-none',
            className
          )}
        />
      </div>
    </div>
  )
}
